<div class="d-flex attribute-item">
    <div class="r">
        <mat-icon>label</mat-icon>
    </div>
    <div class="m-2 name flex-grow-1">{{attribute.name}}</div>
    <div class="options">
        <div class="opt" (click)="deleteConfirm()" title="Xóa">
            <mat-icon>delete_outline</mat-icon>
        </div>
        <div class="opt" (click)="openAttributeKeyForm()" title="Chỉnh sửa khóa">
            <mat-icon>code</mat-icon>
        </div>
        <div class="opt" (click)="openAttributeForm()" title="Chỉnh sửa thuộc tính">
            <mat-icon>create</mat-icon>
        </div>
        <div class="opt" [ngClass]="{'disabled': attribute.order == 0}" (click)="up()" title="Đẩy lên">
            <mat-icon>keyboard_arrow_up</mat-icon>
        </div>
        <div class="opt" [ngClass]="{'disabled': attribute.order == attrLength - 1}" (click)="down()" title="Đẩy xuống">
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
    </div>
    <div class="m-2 is-required" [ngClass]="{'required': isRequired}">
        <mat-slide-toggle class="full" labelPosition="before" color="warn" [disabled]="hasRequired == false"
                            [(ngModel)]="isRequired" (change)="onRequiredChange($event)">
            {{isRequiredText}}
        </mat-slide-toggle>
    </div>
    <div class="m-2 type" style="background-color: aqua;">
        {{type}}
    </div>
</div>
